<script setup>
import { ref, computed, watch } from "vue";
import InputPrice from "@/components/ui/InputPrice.vue";

const props = defineProps({
  name: String,
  taxRates: Array,
  currency: String,
  valuePrice: [String, Number],
  valueOriginalPrice: [String, Number],
  taxRateSelectedId: [String, Number],
  locale: String,
});

const selectedTaxRateAmount = computed(() => {
  return props.taxRates.find(
    (taxRate) => taxRate.id === parseInt(selectedTaxRate.value)
  );
});

const withTax = (value) => {
  if (!value) {
    return null;
  }
  if (!selectedTaxRateAmount.value) {
    return value;
  }
  return (Number(value) * (1 + selectedTaxRateAmount.value.amount / 100));
};
const withoutTax = (value) => {
  if (!value) {
    return value;
  }
  if (!selectedTaxRateAmount.value) {
    return value;
  }
  return (value / (1 + selectedTaxRateAmount.value.amount / 100))
    .toPrecision(6)
};

const inputName = ref(props.name);
const selectedTaxRate = ref(props.taxRateSelectedId);
const taxRateSelected = ref(props.taxRateSelectedId);
const inputPrice = ref(withTax(props.valuePrice));
const inputOriginalPrice = ref(withTax(props.valueOriginalPrice));


const getTaxRateSelected = () => {
  taxRateSelected.value = selectedTaxRate.value;
};

watch(
  () => props.valuePrice,
  (newValue) => {
    inputPrice.value = withTax(newValue);
  }
);

watch(
  () => props.valueOriginalPrice,
  (newValue) => {
    inputOriginalPrice.value = withTax(newValue);
  }
);
</script>
<template>
  <div>
    <div class="form-group">
      <label for="activity_tax_rate">
        {{ $t('Tax rate') }}
      </label>
      <select
        @change="getTaxRateSelected"
        v-model="selectedTaxRate"
        class="form-control"
      >
        <option value="">-- {{ $t('Select a tax rate') }} --</option>
        <option
          v-for="taxRate in taxRates"
          :key="taxRate.id"
          :value="taxRate.id"
        >
          {{ taxRate.name }} : {{ $t('rate') }} {{ taxRate.amount }} %
        </option>
      </select>

      <input
        :name="inputName"
        type="hidden"
        v-model="taxRateSelected"
      />
    </div>

    <div class="form-group">
      <label>{{ $t('Current sale price') }} ({{ $t('Tax inc.') }})</label>
      <InputPrice
        :currency="currency"
        :locale="locale"
        v-model="inputPrice"
        :precision="2"
        class="mb-0"
      />
      <input type="hidden" name="price" :value="withoutTax(inputPrice)">
    </div>

    <div class="form-group">
      <label>{{ $t('Original Price') }} ({{ $t('Tax inc.') }})</label>
      <InputPrice
        :currency="currency"
        :locale="locale"
        v-model="inputOriginalPrice"
      />
      <input type="hidden" name="original_price" :value="withoutTax(inputOriginalPrice)">
      <small class="form-text text-muted">
        {{ $t('If this price is set, it will appear as a “strikethrough price”. The “Current sale price” will always be applied in the cart.') }}
      </small>
    </div>

  </div>
</template>